<script lang="ts" module>
  import { type VariantProps, tv } from 'tailwind-variants';
  import type { WithElementRef } from 'bits-ui';
  import type { HTMLAttributes } from 'svelte/elements';

  export const badgeVariants = tv({
    base: 'focus:ring-ring inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-medium tracking-[-0.005em] transition-colors focus:ring-2 focus:ring-offset-1 focus:outline-none',
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground hover:bg-primary/90 border-transparent',
        secondary:
          'bg-surface-2 text-foreground border-border hover:bg-surface-3',
        destructive:
          'bg-destructive/15 text-destructive border-destructive/40',
        success:
          'bg-success/15 text-success border-success/50 shadow-[0_0_10px_-1px_hsl(var(--success)/0.35)]',
        warning: 'bg-warning/15 text-warning border-warning/50 shadow-[0_0_10px_-1px_hsl(var(--warning)/0.3)]',
        outline: 'text-foreground border-border',
        gold: 'bg-gold/15 text-gold border-gold/40 shadow-[0_0_10px_-2px_hsl(var(--gold)/0.35)]',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  });

  export type BadgeVariant = VariantProps<typeof badgeVariants>['variant'];
  export type BadgeProps = WithElementRef<HTMLAttributes<HTMLSpanElement>> & {
    variant?: BadgeVariant;
  };
</script>

<script lang="ts">
  import { cn } from '$lib/utils';

  let {
    class: className,
    variant = 'default',
    ref = $bindable(null),
    children,
    ...restProps
  }: BadgeProps = $props();
</script>

<span
  bind:this={ref}
  class={cn(badgeVariants({ variant }), className)}
  {...restProps}
>
  {@render children?.()}
</span>
